import { useLocation } from 'react-router-dom';
import { CustodianTopBar } from '../components/layout/custodian/CustodianTopBar';
import { CustodianIconRail } from '../components/layout/custodian/CustodianIconRail';
import { titleForPath } from '../routes/pathTitles';
import { WorkspaceGate } from './WorkspaceGate';

function cleanTitle(title) {
  return title.replace(/^Custodian(?:\s+workspace)?\s*[—-]\s*/i, '');
}

export function CustodianShell() {
  const { pathname } = useLocation();
  const { title, subtitle } = titleForPath(pathname);

  return (
    <div className="flex h-screen flex-col bg-eorig-surface pt-3 font-sans text-sm text-eorig-ink">
      <CustodianTopBar />
      <div className="flex min-h-0 flex-1 overflow-hidden">
        <CustodianIconRail />
        <main className="min-w-0 flex-1 overflow-y-auto px-4 py-5 sm:px-6 sm:py-6">
          <div className="mx-auto w-full max-w-7xl">
            <WorkspaceGate title={cleanTitle(title)} subtitle={subtitle} />
          </div>
        </main>
      </div>
    </div>
  );
}
